export const sentByMe = ({ invitedBy, myId }) => invitedBy.id === myId;
